import React from 'react';
import { PageHero, CtaRow } from '../PublicLayout';
import { SAFETY_POINTS } from '../content';

export default function SafetyPage() {
  return (
    <>
      <PageHero
        eyebrow="Your money, protected"
        title="Safety & wallet"
        subtitle="LockedIn is built around clear, committed challenges. Here's how funds and settlement stay transparent."
      />
      <section className="max-w-6xl mx-auto px-4 sm:px-6 pb-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {SAFETY_POINTS.map((p) => (
            <div key={p.title} className="rounded-2xl border border-white/10 bg-white/[0.03] p-6">
              <span className="text-[11px] font-black uppercase tracking-[0.28em] text-emerald-400 mb-4 block" aria-hidden>{p.icon}</span>
              <h3 className="text-base font-black tracking-tight text-white mb-2">{p.title}</h3>
              <p className="text-sm text-gray-400 leading-relaxed">{p.body}</p>
            </div>
          ))}
        </div>
      </section>
      <section className="max-w-3xl mx-auto px-4 sm:px-6 py-10 border-t border-white/5">
        <h2 className="text-2xl font-black tracking-tight text-white mb-4">How locked funds work</h2>
        <p className="text-gray-400 text-base font-medium leading-relaxed mb-4">
          When you create a challenge and someone accepts it, both entries move into locked funds. Neither
          player can access those funds until the challenge settles. Live games settle from final scores;
          custom challenges settle from the outcome both players agreed to.
        </p>
        <p className="text-gray-400 text-base font-medium leading-relaxed">
          The winner reviews a clear transfer breakdown and claims the pool, minus the platform service fee.
          Eligible available balance can be withdrawn to a connected bank account through Stripe.
        </p>
      </section>
      <section className="max-w-3xl mx-auto px-4 sm:px-6 py-12 text-center">
        <CtaRow />
      </section>
    </>
  );
}
